import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import { Link, LinkProps } from './link/link';

export interface MagicLinkProps {
  data?: LinkProps;
  status: LoadingState;
}

export const MagicLink = types
  .model({
    data: types.optional(Link, {}),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: MagicLinkProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
    setData(props: Partial<MagicLinkProps>): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        data: { ...self.data, ...props },
      });
    },
  }))
  .actions((self) => ({
    async setStore(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.magicLink,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setStore();
    },
    async update(): Promise<void> {
      await self.setStore();
    },
  }))
  .views((self) => ({
    getMagicLinkUrl(): string | undefined {
      const { data } = self;
      return getSnapshot(data).magicLink;
    },
  }));

export const magicLink = MagicLink.create();
export type MagicLinkSnapshot = SnapshotIn<typeof MagicLink>;
export type MagicLinkInstance = Instance<typeof MagicLink>;
export default magicLink;
